<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M6 6.5a1.5 1.5 0 100 3h28a1.5 1.5 0 000-3H6zm22 13a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM16.5 28c0-6.351 5.149-11.5 11.5-11.5S39.5 21.649 39.5 28a11.45 11.45 0 01-2.377 7.002l5.938 5.937a1.5 1.5 0 01-2.122 2.122l-5.937-5.938A11.45 11.45 0 0128 39.5c-6.351 0-11.5-5.149-11.5-11.5zm-12-10A1.5 1.5 0 016 16.5h9a1.5 1.5 0 010 3H6A1.5 1.5 0 014.5 18zM6 26.5a1.5 1.5 0 000 3h5a1.5 1.5 0 000-3H6z"/></svg>